import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import variants from '../../graphql/variants';
import useErrorHandler from '../useErrorHandler';
import {
  GetVariants,
  GetVariants_trim_attributes,
  GetVariants_trimLevelVariants_variants,
  GetVariantsVariables,
} from '../../graphql/__generated__/GetVariants';
import { useFinanceFormInput } from '../useFinanceFormInput';
import useGetPostCode from '../useGetPostCode';
import usePostcodeErrorHandler from '../usePostcodeErrorHandler';
import usePostcodeContext from '../usePostcodeContext';
import IParams from '../../../gqlCustomise/model/IParams';

const useVariants = () => {
  const { trimCode } = useParams<IParams>();
  const { togglePostcodeLoading } = usePostcodeContext();
  const { financeFormInput, financeInput } = useFinanceFormInput();
  const [trimData, setTrimData] = useState<GetVariants_trim_attributes>(null);
  const [variantsData, setVariantsData] = useState<GetVariants_trimLevelVariants_variants[]>(null);
  const [errorState, setErrorState] = useState(null);
  const postCode = useGetPostCode();

  const { data, loading, refetch, error } = useQuery<GetVariants, GetVariantsVariables>(variants.GET_VARIANTS, {
    variables: {
      trimCode,
      filters: { trimCode },
      financeFormInput,
      financeInput,
      financeProductId: financeFormInput?.financeProductId,
      postCode,
    },
  });

  const reFetch = useCallback(() => {
    refetch();
  }, []);

  useEffect(() => {
    if (!loading) {
      setTrimData(data?.trim.attributes);
      setVariantsData(data?.trimLevelVariants.variants);
      togglePostcodeLoading(false);
    }
  }, [data]);

  usePostcodeErrorHandler(error, loading, setErrorState);
  useErrorHandler(error);

  return { trimData, variantsData, loading, error: errorState, reFetch };
};

export default useVariants;
